import { Svg, Path } from "@react-pdf/renderer";
export const LightningLogo = (): JSX.Element => {
	return (
		<Svg width="15" height="15" viewBox="0 0 30 30">
			<Path
				d="M2.063 0h7.663L6.78 9.874h9.726L5.158 27.853l2.21-10.169H0L2.063 0z"
				fill="#F8CC1E"
				fill-rule="evenodd"
			/>
		</Svg>
	);
};
